<button type="button" [disabled]="disabled" [ngClass]="class">
  <i class="mr-2" [ngClass]="icon"></i><ng-content></ng-content>
</button>
